import {
    faSpinnerThird
} from '@fortawesome/pro-duotone-svg-icons/faSpinnerThird';
import {
    FontAwesomeIcon
} from '@fortawesome/react-fontawesome';
import {
    Box,
    useTheme
} from '@mui/material';
import {
    type FC
} from 'react';

import type {
    InlineLoaderProps
} from './types';

import styles from './styles';

const InlineLoader: FC<InlineLoaderProps> = (props) => {
    const {
        height
    } = props;

    const theme = useTheme();

    return (
        <Box sx={[
            ...(Array.isArray(styles.wrapper) ? styles.wrapper : [
                styles.wrapper
            ]),
            {
                height
            }
        ]}
        >
            <FontAwesomeIcon
                color={theme.colors.pacificTeal}
                icon={faSpinnerThird}
                size={'5x'}
                spin
            />
        </Box>
    );
};

export default InlineLoader;
